import { MutationTree } from 'vuex';
import { SuiviFinancierState } from '.';
import { SUIVI_FINANCIER } from './mutation-types';
import { SortType } from '@/models/SortType';
import { SuiviFinancier, SuiviFinancierFull } from '@/models/SuiviFinancier';
import { TableHeader } from '@/models/TableHeader';

export const mutations: MutationTree<SuiviFinancierState> = {

    [SUIVI_FINANCIER.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },
    [SUIVI_FINANCIER.SET_FILTER_SITE](state, siteList: number[]) {
        state.siteList = siteList;
    },

    [SUIVI_FINANCIER.SET_ITEMS_SUIVI_FINANCIER](state, items: SuiviFinancier[]) {
        const suivis : SuiviFinancier[] = [];
        const suivisFull : SuiviFinancierFull[] = [];
        items.forEach(suiviFinancier => {
            suivis.push(new SuiviFinancier(suiviFinancier));
            suivisFull.push(new SuiviFinancierFull(suiviFinancier));
        });
        state.factures = suivis;
        state.facturesWithChantierId = suivisFull;
    },
    [SUIVI_FINANCIER.ADD_ITEMS](state, items: SuiviFinancier[]) {
        const suivis : SuiviFinancier[] = [];
        const suivisFull : SuiviFinancierFull[] = [];
        items.forEach(suiviFinancier => {
            suivis.push(new SuiviFinancier(suiviFinancier));
            suivisFull.push(new SuiviFinancierFull(suiviFinancier));
        });
        state.factures = [...state.factures, ...suivis];
        state.facturesWithChantierId = [...state.facturesWithChantierId, ...suivisFull];
    },
    [SUIVI_FINANCIER.RESET_ITEMS](state) {
        state.factures = [];
        state.pageSuiviFinancier = 0;
    },
   [SUIVI_FINANCIER.SET_PAGE](state, page: number) {
        state.pageSuiviFinancier = page;
    },
    [SUIVI_FINANCIER.SET_NB_PAGES](state, pages: number) {
        state.nbOfPages = pages;
    },
    [SUIVI_FINANCIER.SET_SORT_SUIVI_FINANCIER](
        state: SuiviFinancierState,
        sort: {
                  sortData: string;
                  sortStatus: SortType;
              }
    ) {
        state.tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return [...newTable, headerItem];
        }, [] as TableHeader[]);
        state.sort = sort;
    },
    [SUIVI_FINANCIER.SET_IS_LOADING_SUIVI_FINANCIER](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [SUIVI_FINANCIER.SET_XLS_IS_LOADING](state, isLoading: boolean) {
        state.xlsLoading = isLoading;
    },
    [SUIVI_FINANCIER.SET_ERROR_SUIVI_FINANCIER](state, error: Error | undefined) {
        state.error = error;
    },
    [SUIVI_FINANCIER.SET_PDF_IS_LOADING](state, isLoading: boolean) {
        state.pdfLoading = isLoading;
    },
};
